import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';

import { CreateAssignmentDrawer } from './CreateAssignmentDrawer';

export const CreateAssignmentButton = () => {
    const { push, pop } = useDrawer();

    const openDrawer = () => {
        const drawerId = push({
            header: { title: translate('assignments.admin.invite') },
            content: <CreateAssignmentDrawer onSuccess={() => pop(drawerId)} />,
        });
    };

    return (
        <Button emphasis="high" LeadingIcon={IconPlus} onClick={openDrawer}>
            {translate('assignments.admin.invite')}
        </Button>
    );
};
